export default "__VITE_ASSET__CgpE14U___"